import { View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import Projection from './Projection';
function ProjectionsPage({ projections }) {
    return (React.createElement(React.Fragment, null, projections.map((projection) => {
        const hasTechnologistComments = projection.points.some((point) => point.typeCode === 'TECHNOLOGIST');
        return (React.createElement(Fragment, { key: projection.id },
            React.createElement(View, { break: true },
                React.createElement(Projection, { projection: projection, type: "DESIGNER" })),
            hasTechnologistComments && (React.createElement(View, { break: true },
                React.createElement(Projection, { projection: projection, type: "TECHNOLOGIST" })))));
    })));
}
export default ProjectionsPage;
